import { render, staticRenderFns } from "./SwiperNav.vue?vue&type=template&id=2a802dd7"
import script from "./SwiperNav.vue?vue&type=script&lang=js"
export * from "./SwiperNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports